import React, {Component} from 'react';
import {connect} from 'react-redux';
import Scoreboard from "../components/scoreboard";
import Register from "../components/register";
import {bindActionCreators} from "redux";
import { register, share } from "../reducers/auth";
import Hero from '../components/hero.js';
import {Form, Control} from "react-redux-form";
import {Link} from "react-router-dom";
import { toggleModal } from "../reducers/content";

function mapStateToProps(state) {
	return {auth: state.auth, scoreboard: state.scoreboard};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	register,
	share,
	toggleModal
}, dispatch)

class CTABlock extends React.Component {

	render(){
		return (
			<React.Fragment>
				<h3 className="white-text bold">Start now</h3>

				<button onClick={(e) => {
					e.preventDefault();
					this.props.changeHomepageFormState('register')
				}} className="btn-blue_light bold mb-4 btn-hover sign-up mt-3">SIGN UP
				</button>

				<div onClick={(e) => {e.preventDefault(); this.props.changeHomepageFormState('share')}} className="btn-lights bold btn-hover">CHALLENGE YOUR FRIEND</div>
			</React.Fragment>
		)
	}
}

class RegFormBlock extends React.Component {

	render(){
		return (
			<React.Fragment>
				<h3 className="white-text bold">Start now</h3>

				<Register onSubmit={(val) => {
					// this.props.changeHomepageFormState('reset');

					this.props.register(val);
				}} {...this.props} />
			</React.Fragment>
		)
	}
}

class ShareFormBlock extends React.Component {

	render(){
		return (
			<React.Fragment>
				<h3 className="white-text bold">Challenge Your Friend</h3>

				<Form onSubmit={this.props.share} model={'auth.share'}>
					<div className="position-relative input-effect">
						<Control.text model={'.YourName'} className={!!this.props.auth.share.YourName ? 'effect has-content' : 'effect'} type="text" />
						<label>Your Name</label>
					</div>
					<div className="position-relative input-effect">
						<Control.text model={'.YourEmail'} className={!!this.props.auth.share.YourEmail ? 'effect has-content' : 'effect'} type="text" />
						<label>Your Email</label>
					</div>
					<div className="position-relative input-effect">
						<Control.text model={'.ShareName'} className={!!this.props.auth.user.ShareName ? 'effect has-content' : 'effect'} type="text" />
						<label>Your Friend's Name</label>
					</div>
					<div className="position-relative input-effect">
						<Control.text model={'.ShareEmail'} className={!!this.props.auth.user.ShareEmail ? 'effect has-content' : 'effect'} type="text" />
						<label>Your Friend's Email</label>
					</div>

					<input type="submit" className="submit bold btn-hover" value="Send" />
				</Form>
			</React.Fragment>
		)
	}
}

class Home extends Component {
	state  = {
		showRegistration: false,
		showFriendChallenge: false
	}

	changeHomepageFormState(type) {
		if(type === 'register'){
			this.setState({
				showRegistration: true,
				showFriendChallenge: false
			})
		}
		else if(type === 'share'){
			this.setState({
				showFriendChallenge: true,
				showRegistration: false
			})
		}
	}

	render() {
		let now = new Date();
		let a = new Date('2020-05-15 12:00:00'),
			b = new Date(),
			diff = (+a - +b);

		return (
			<main className="">
				<Hero {...this.props} />

				<section className="content bg-color_gradient paddingLeft-120 shadow-top">
					<div className="row">
						<div className="col-12 col-lg-6">
							<div className="content__left">
								<div className="text">
									<h3 className="blue-text bold">How does it work?</h3>
									<p>Prove your investigation skills with 25 IR challenges, crafted by top industry experts. Test your knowledge as you move from one challenge to another as they become increasingly harder, winning additional points with each solved challenge. Time makes a difference! The quicker you answer the more points you score.</p>

									{diff > 0 &&
										<React.Fragment>
											<h4 className="blue-text bold">The Winner Takes It All</h4>
											<p>The winner gets $5,000 USD and more importantly - worldwide recognition as a master of incident response and forensic investigations.</p>
										</React.Fragment>
									}
								</div>
								<div className="d-flex box-column_lg">
									<Link to={'/example'} className="btn-blue btn-hover">See Challenge Example</Link>
									<button onClick={(e) => {e.preventDefault(); this.props.toggleModal('rules')}} className="btn-trans btn-hover ml-md-13">Competition Rules</button>
								</div>
							</div>
						</div>
						<div className="col-12 col-lg-6">
							<div className="content__right">
								<div className="row">
									<div className="col-12 d-none d-md-block col-md-6 col-lg-12">
										<div className="form-style">
											{!this.state.showRegistration && !this.state.showFriendChallenge &&
												<React.Fragment>
													{!this.props.auth.token && <CTABlock changeHomepageFormState={(type) => this.changeHomepageFormState(type)} {...this.props} />}
												</React.Fragment>
											}

											{this.state.showRegistration && !this.props.auth.token && <RegFormBlock changeHomepageFormState={(type) => this.changeHomepageFormState(type)} {...this.props} />}

											{this.state.showFriendChallenge &&
												<ShareFormBlock changeHomepageFormState={(type) => this.changeHomepageFormState(type)} {...this.props} />
											}
										</div>
									</div>

									{!this.state.showRegistration &&
										<div className="col-12 col-md-6 col-lg-12">
											<div className="leader">
												<div className="date">{now.toLocaleString()}</div>
												<h3 className="white-text bold">Leader Scoreboard</h3>

												<Scoreboard {...this.props} />

												<Link to={'/halloffame'} className="blue-link d-none d-md-block">
													Visit the Hall of Fame
												</Link>
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
				</section>
			</main>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Home);